import { WidgetForm } from "@/components/widget/widget-form";

export function NewWidgetPage() {
  return <WidgetForm mode="create" />;
}
